/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import * as S from './style.TotalYield';
import SearchSelector from "../../components/form/SearchSelector";
import SearchSelectorNew from '../../components/form/SearchSelectorNew';
import TableForm from "../../components/form/TableForm";
import React, {ChangeEvent, startTransition, useEffect, useState} from "react";
import {CSVHeader, ISearchBox, TableHeader, IDropDown} from "../../types/type";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../modules";
import ApiUtil from '../../utils/ApiUtil';
import { IDevice, ILotNumber, ITotalYield, TotalCol, ICustomerPn } from '../../types/userData';
import { getDate, getDateString, getMonthToMinute } from '../../utils/dateUtil';
import { showAlertModal } from '../../modules/action/alertAction';


const TotalYield = () => {
    const langState = useSelector((state:RootState) => state.langReducer);

    const tableHeaders:TableHeader[] = [   
       {text: langState.isKor? "고객PO"         :"Customer P/N"     , width: "140px"},
        {text: langState.isKor? "제품명"         :"SAWNICS P/N"     , width: "140px"},
        {text: langState.isKor? "로트"         :"LOT"     , width: "120px"},
        // {text: langState.isKor? "차수"         :"Test Number"     , width: "100px"},
        {text: langState.isKor? "Wafer ID"      :"Wafer ID"     , width: "130px"},
        {text: langState.isKor? "PROBE(Total)" :"PROBE(Total)"     , width: "30px"},
        {text: langState.isKor? "PROBE(Pass)"  :"PROBE(Pass)"     , width: "30px"},
        {text: langState.isKor? "PROBE(Fail)"  :"PROBE(Fail)"     , width: "30px"},
        {text: langState.isKor? "PROBE(YLD)" :  "PROBE(YLD)"     , width: "30px"},
        //{text: langState.isKor? "Bin2(PROBE)"  :"Bin2(PROBE)"     , width: "100px"},
        //{text: langState.isKor? "Bin3(PROBE)"  :"Bin3(PROBE)"     , width: "100px"},
        //{text: langState.isKor? "Bin4(PROBE)"  :"Bin4(PROBE)"     , width: "100px"},
        //{text: langState.isKor? "Bin5(PROBE)"  :"Bin5(PROBE)"     , width: "100px"},
        //{text: langState.isKor? "Bin6(PROBE)"  :"Bin6(PROBE)"     , width: "100px"},
        //{text: langState.isKor? "Bin7(PROBE)"  :"Bin7(PROBE)"     , width: "100px"},
        //{text: langState.isKor? "Bin8(PROBE)"  :"Bin8(PROBE)"     , width: "100px"},
        {text: langState.isKor? "AVI(Total)"   :"AVI(Total)"     , width: "30px"},
        {text: langState.isKor? "AVI(Pass)"    :"AVI(Pass)"     , width: "30px"},
        {text: langState.isKor? "AVI(YLD)"   :"AVI(YLD)"     , width: "30px"},
        {text: langState.isKor? "Shipping Date":"Shipping Date"     , width: "100px"},
        //{text: langState.isKor? "Cum Yield":"Cum Yield"     , width: "100px"},
        
    ];
    
    const CSVHeaders:CSVHeader[] = [
        {label: langState.isKor? "고객PO" :"Customer P/N",                  key: "cust_pn"   ,value: "CUST_PN"            },
        {label: langState.isKor? "제품명" :"SAWNICS P/N",                  key: "device"     ,value: "DEVICE"           },
        {label: langState.isKor? "로트" : "LOT" ,                   key: "lotNumber"         ,value: "LOT_NUMBER"           },
        // {label: langState.isKor? "차수" : "Test Number" ,           key: "turn"},
        {label: langState.isKor? "Wafer ID" :"Wafer ID" ,             key: "waferId"         ,value: "WAFER_ID"           },
        {label: langState.isKor? "PROBE(Total)" : "PROBE(Total)" ,  key: "totalProbe"        ,value: "TESTCOUNT"           },
        {label: langState.isKor? "PROBE(Pass)"  : "PROBE(Pass)" ,   key: "passProbe"         ,value: "PASSCOUNT"            },
        {label: langState.isKor? "PROBE(Fail)"  : "PROBE(Fail)" ,   key: "failProbe"         ,value: "FAILCOUNT"           },
        {label: langState.isKor? "PROBE(YLD)" : "PROBE(YLD)" ,  key: "yieldProbe"            ,value: "YIELD_PTEST"           },
        //{label: langState.isKor? "Bin2(PROBE)"  : "Bin2(PROBE)" ,   key: "b2"},
        //{label: langState.isKor? "Bin3(PROBE)"  : "Bin3(PROBE)" ,   key: "b3"},
        //{label: langState.isKor? "Bin4(PROBE)"  : "Bin4(PROBE)" ,   key: "b4"},
        //{label: langState.isKor? "Bin5(PROBE)"  : "Bin5(PROBE)" ,   key: "b5"},
        //{label: langState.isKor? "Bin6(PROBE)"  : "Bin6(PROBE)" ,   key: "b6"},
        //{label: langState.isKor? "Bin7(PROBE)"  : "Bin7(PROBE)" ,   key: "b7"},
        //{label: langState.isKor? "Bin8(PROBE)"  : "Bin8(PROBE)" ,   key: "b8"},
        {label: langState.isKor? "AVI(Total)"   : "AVI(Total)" ,    key: "totalAvi"          ,value: "TOTAL_AVI"           },
        {label: langState.isKor? "AVI(Pass)"  : "AVI(Pass)" ,       key: "passAvi"           ,value: "PASS_AVI"           },
        {label: langState.isKor? "AVI(YLD)" : "AVI(YLD)",       key: "yieldAvi"              ,value: "YIELD_AVI"           },
        {label: langState.isKor? "Shipping Date" : "Shipping Date" ,key: "shipmentDate"       ,value: "SHIPMENT_DATE"          },
        //{label: langState.isKor? "Cum Yield" : "Cum Yield" ,key: "cumYield"},

    ];

    const [checkedDevices, setCheckedDevices] = useState<ISearchBox[]>([]);
    const [devices, setDevices] = useState<ISearchBox[]>([]);
    const [lotNumbers, setLotnumbers] = useState<ISearchBox[]>([]);
    const [checkedLotNumbers, setCheckedLotNumbers] = useState<ISearchBox[]>([]);
    const [searchData,setSearchData] = useState<ITotalYield[]>([]);
    const [isLookDown,setIsLookDown] = useState(false);
    const [tableBodies, setTableBodies] = useState<JSX.Element>((<tbody></tbody>));
    //const [startDate,setStartDate] = useState(new Date("2000-01-01"));
    var now = new Date();
    const [startDate,setStartDate] = useState(new Date(now.setDate(now.getDate()-30)));

    const [endDate,setEndDate] = useState(new Date());
    const [existBothData, setExistBothData] = useState(false);
    const [baseYield] = useState("");
    const [originTotalRowCnt, setOriginTotalRowCnt] = useState<number>(0);

    const [customerPns, setCustomerPns] = useState<ISearchBox[]>([]);
    const [checkedCustomerPns, setCheckedCustomerPns] = useState<ISearchBox[]>([]);   
    const [sortHeader, setSortHeader] = useState<IDropDown[]>([]);
    const [sortType, setSortType] = useState<IDropDown[]>([]);

    const [sortingCol, setSortingCol] = useState<number[]>([2]); // Sorting 할 해더 인덱스

    const dispatch = useDispatch();

    const onSubmit = (event : React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        async function callAPI(){
                const params:object ={
                    dates : {
                        startDate : getDateString(startDate),
                        endDate : getDateString(endDate)
                    },
                    devices : checkedDevices,
                    lotNumbers : checkedLotNumbers,
                    checkBoxOne : existBothData,
                    inputTextOne : baseYield,
                    customerPn : checkedCustomerPns,
                    sortColumns : sortHeader,
                    sortTypes : sortType,
                    
                }

                const res = await ApiUtil.post("/search/total-yield-report",params);
                setOriginTotalRowCnt(res.data.totalYieldReport.length);
                if(res.data.totalYieldReport.length ==0){
                    if(langState.isKor)
                    {
                        dispatch(showAlertModal("확인메세지","데이터","가 없습니다."));
                    }else{
                        dispatch(showAlertModal("Information","Data"," does not exist."));
                    }
                }
                searchData.splice(0,searchData.length);
                setSearchData(res.data.totalYieldReport);
        }
        callAPI();
    }

    useEffect(() =>{
        async function callAPI(){
            const res = await ApiUtil.get("/condition/deviceAndLotNumberAndOperation",);

            devices.splice(0, devices.length);
            res.data.devices.map((device:IDevice)=>{
                return devices.push({
                    id : device.deviceId,
                    text : device.description,
                })
            })
            setDevices(devices);

            lotNumbers.splice(0, lotNumbers.length);
            res.data.lotNumbers.map((lotNumber:ILotNumber) =>{
                return lotNumbers.push({
                    id : lotNumber.id,
                    text : lotNumber.id
                })
            })
            setLotnumbers(lotNumbers);

            customerPns.splice(0, customerPns.length);
            res.data.customerPn.map((customerPn:ICustomerPn) =>{
                return customerPns.push({
                    text : customerPn.label,
                    id : customerPn.value,
                })
            })
            setCustomerPns(customerPns);

        }
        callAPI();
    },[devices,lotNumbers]) 

    useEffect(()=>{
        
        let cust_pn:string = "";
        let device:string = "";
        let lotNumber:string ="";
        let turn:string ="";
        let counter:number = 0;
        const totalCol:TotalCol[] = [];
        const lotNumberCol:TotalCol[] = [];
        const turnCol:TotalCol[] = [];


        let totalProbe:number = 0;
        let passProbe:number =0;
        let failProbe:number = 0;
        let totalAvi:number = 0;
        let passAvi:number = 0;

        //Total
        searchData.map((element,index)=>{
            if(element.totalProbe != undefined && typeof element.totalProbe ==='number'){
                totalProbe += element.totalProbe;
            }
            if(element.passProbe != undefined && typeof element.passProbe ==='number'){
                passProbe += element.passProbe;
            }
            if(element.failProbe != undefined && typeof element.failProbe ==='number'){
                failProbe += element.failProbe;
            }
            if(element.totalAvi != undefined && typeof element.totalAvi ==='number'){
                totalAvi += element.totalAvi;
            }
            if(element.passAvi != undefined && typeof element.passAvi ==='number'){
                passAvi += element.passAvi;
            }
          
            if(index == 0){
                totalCol.push({
                    //@ts-ignore
                    rowCount : element.yieldAvi !=undefined? 1 : 0, //yieldAvi total 계산을 위한 카운트
                    //@ts-ignore
                    YieldAvi : element.yieldAvi !=undefined? element.yieldAvi : 0,

                    //@ts-ignore
                    rowCountThree : element.yieldProbe != undefined && element.yieldProbe !=0? 1 : 0, //yieldProbe total 계산을 위한 카운트
                    //@ts-ignore
                    YieldProbe : element.yieldProbe !=undefined? element.yieldProbe : 0,

                    //@ts-ignore
                    deviceName : element.device,
                })
            }else{
                //@ts-ignore
                totalCol[totalCol.length-1].rowCount += element.yieldAvi !=undefined? 1 : 0;
                //@ts-ignore
                totalCol[totalCol.length-1].YieldAvi += element.yieldAvi !=undefined? element.yieldAvi : 0;
                //@ts-ignore
                totalCol[totalCol.length-1].rowCountThree += element.yieldProbe !=undefined && element.yieldProbe !=0? 1 : 0;
                //@ts-ignore
                totalCol[totalCol.length-1].YieldProbe += element.yieldProbe != undefined? element.yieldProbe:0;
                
                //@ts-ignore
                totalCol[totalCol.length-1].deviceName  = element.device;
                
            }
        })

           //turn
           searchData.map((element,index)=>{
            if(index === 0){
                console.log("0번째 인덱스"+index);
                //@ts-ignore
                lotNumber = element.lotNumber; //1. Lotnumber 상관없이 처음  turn부터 갯수를 분류하기위해 세팅(lotnumber에 여러 turn이 걸릴수 있어서)
            }
            
            if(element.lotNumber == lotNumber){  //2. 첫행의 처음 turn 부터 수집 시작 lotNumber를 맞춰서 무조건 타게한다.
                if(element.turn != turn &&
                    element.turn != null &&
                    element.turn != undefined){ //2-1. 동일 Lotnumber 내에서 turn만 바뀐경우 lotNumberCol push
                        turn = element.turn;
                        turnCol.push({
                            rowCount: 1,
                            //@ts-ignore
                            cust_pn : element.cust_pn,
                            //@ts-ignore
                            deviceName : element.device,
                            lotNumber : element.lotNumber,
                            turn : element.turn,
                            waferId : element.waferId,
                            TestDieProbe : element.totalProbe != undefined && typeof element.totalProbe === "number"? element.totalProbe : 0,
                            GoodDieProbe : element.passProbe != undefined && typeof element.passProbe === "number"? element.passProbe : 0,
                            FailDieProbe : element.failProbe != undefined && typeof element.failProbe === "number"? element.failProbe : 0,
                            YieldProbe : element.yieldProbe != undefined && typeof element.yieldProbe === "number"? element.yieldProbe : 0,
                            TestDieAvi : element.totalAvi != undefined && typeof element.totalAvi === "number"? element.totalAvi : 0,
                            GoodDieAvi : element.passAvi != undefined && typeof element.passAvi === "number"? element.passAvi : 0,
                            YieldAvi : element.yieldAvi != undefined && typeof element.yieldAvi === "number"? element.yieldAvi : 0,
                        })
                    }else {
                        turnCol[turnCol.length-1].rowCount++;
                        turnCol[turnCol.length-1].TestDieProbe   += element.totalProbe != undefined && typeof element.totalProbe === "number"? element.totalProbe : 0;
                        turnCol[turnCol.length-1].GoodDieProbe += element.passProbe != undefined && typeof element.passProbe === "number"? element.passProbe : 0;
                        turnCol[turnCol.length-1].FailDieProbe += element.failProbe != undefined && typeof element.failProbe === "number"? element.failProbe : 0;
                        turnCol[turnCol.length-1].YieldProbe += element.yieldProbe != undefined && typeof element.yieldProbe === "number"? element.yieldProbe : 0;
                        turnCol[turnCol.length-1].TestDieAvi += element.totalAvi != undefined && typeof element.totalAvi === "number"? element.totalAvi : 0;
                        turnCol[turnCol.length-1].GoodDieAvi += element.passAvi != undefined && typeof element.passAvi === "number"? element.passAvi : 0;
                        turnCol[turnCol.length-1].YieldAvi += element.yieldAvi != undefined && typeof element.yieldAvi === "number"? element.yieldAvi : 0;
                        
                    }

            }else{ //3. LotNumber가 달라지면 turn 동일 유무와 상관없이 새로 push
                //@ts-ignore
                lotNumber = element.lotNumber; //현재 새로 수집한 turn의 lotnumber 세팅
                //@ts-ignore
                turn = element.turn;
                turnCol.push({
                    rowCount: 1,
                    //@ts-ignore
                    cust_pn : element.cust_pn,
                    //@ts-ignore
                     deviceName : element.device,
                     //@ts-ignore
                     lotNumber : element.lotNumber,
                     //@ts-ignore
                     waferId : element.waferId,
                    turn : element.turn,
                    TestDieProbe : element.totalProbe != undefined && typeof element.totalProbe === "number"? element.totalProbe : 0,
                    GoodDieProbe : element.passProbe != undefined && typeof element.passProbe === "number"? element.passProbe : 0,
                    FailDieProbe : element.failProbe != undefined && typeof element.failProbe === "number"? element.failProbe : 0,
                    YieldProbe : element.yieldProbe != undefined && typeof element.yieldProbe === "number"? element.yieldProbe : 0,
                    TestDieAvi : element.totalAvi != undefined && typeof element.totalAvi === "number"? element.totalAvi : 0,
                    GoodDieAvi : element.passAvi != undefined && typeof element.passAvi === "number"? element.passAvi : 0,
                    YieldAvi : element.yieldAvi != undefined && typeof element.yieldAvi === "number"? element.yieldAvi : 0,
                })
            }
        })
        
        //turn total 삽입
        for(let i =0; i<turnCol.length;i++){
            let tempProbeYield:number = turnCol[i].GoodDieProbe/turnCol[i].TestDieProbe;
            let tempAviYield:number = turnCol[i].GoodDieAvi/turnCol[i].TestDieAvi;
            
            //i==0? counter += turnCol[i].rowCount : counter += turnCol[i].rowCount+1 ;
            
            searchData.splice(counter,0,{
                cust_pn : turnCol[i].cust_pn, 
                device : turnCol[i].deviceName,
                lotNumber : turnCol[i].lotNumber,
                turn : turnCol[i].turn + "*",
                colSpanFour : turnCol[i].rowCount,
                isTurn : true,
                cellColor : '#EEB8B8',
                totalProbe : (turnCol[i].TestDieProbe).toString(),
                passProbe : (turnCol[i].GoodDieProbe).toString(),
                failProbe : (turnCol[i].FailDieProbe).toString(),
                totalAvi : (turnCol[i].TestDieAvi).toString(),
                passAvi : (turnCol[i].GoodDieAvi).toString(),

                //Probe와 AVI 2개중 하나라도 0인경우
                yieldProbe : turnCol[i].GoodDieProbe !=undefined && turnCol[i].GoodDieProbe >0? +(tempProbeYield * 100).toFixed(2) : 0,
                yieldAvi : turnCol[i].GoodDieAvi !=undefined && turnCol[i].GoodDieAvi >0? +(tempAviYield * 100).toFixed(2): 0,
            })
            counter += turnCol[i].rowCount +1;           
        }
 
        cust_pn = "";
        device = "";
        lotNumber = "";

        //lotNumber
        searchData.map((element, index) => {
            if (index === 0) {
                console.log("0번째 인덱스" + index);
                //@ts-ignore
                device = element.device;
            }

            if (element.device == device) {
                if (element.lotNumber != lotNumber &&
                    element.lotNumber != null &&
                    element.lotNumber != undefined) {
                    lotNumber = element.lotNumber;
                    lotNumberCol.push({
                        rowCount: 1,
                        //@ts-ignore
                        cust_pn: element.cust_pn,
                        //@ts-ignore
                        deviceName: element.device,
                        lotNumber: element.lotNumber,
                        waferId: element.waferId,
                        TestDieProbe: element.totalProbe != undefined && typeof element.totalProbe === "number" ? element.totalProbe : 0,
                        GoodDieProbe: element.passProbe != undefined && typeof element.passProbe === "number" ? element.passProbe : 0,
                        FailDieProbe: element.failProbe != undefined && typeof element.failProbe === "number" ? element.failProbe : 0,
                        YieldProbe: element.yieldProbe != undefined && typeof element.yieldProbe === "number" ? element.yieldProbe : 0,
                        TestDieAvi: element.totalAvi != undefined && typeof element.totalAvi === "number" ? element.totalAvi : 0,
                        GoodDieAvi: element.passAvi != undefined && typeof element.passAvi === "number" ? element.passAvi : 0,
                        YieldAvi: element.yieldAvi != undefined && typeof element.yieldAvi === "number" ? element.yieldAvi : 0,
                        YieldCum: element.cumYield != undefined && typeof element.cumYield === "number" ? element.cumYield : 0,
                    })
                } else {
                    lotNumberCol[lotNumberCol.length - 1].rowCount++;
                    lotNumberCol[lotNumberCol.length - 1].TestDieProbe += element.totalProbe != undefined && typeof element.totalProbe === "number" ? element.totalProbe : 0;
                    lotNumberCol[lotNumberCol.length - 1].GoodDieProbe += element.passProbe != undefined && typeof element.passProbe === "number" ? element.passProbe : 0;
                    lotNumberCol[lotNumberCol.length - 1].FailDieProbe += element.failProbe != undefined && typeof element.failProbe === "number" ? element.failProbe : 0;
                    lotNumberCol[lotNumberCol.length - 1].YieldProbe += element.yieldProbe != undefined && typeof element.yieldProbe === "number" ? element.yieldProbe : 0;
                    lotNumberCol[lotNumberCol.length - 1].TestDieAvi += element.totalAvi != undefined && typeof element.totalAvi === "number" ? element.totalAvi : 0;
                    lotNumberCol[lotNumberCol.length - 1].GoodDieAvi += element.passAvi != undefined && typeof element.passAvi === "number" ? element.passAvi : 0;
                    lotNumberCol[lotNumberCol.length - 1].YieldAvi += element.yieldAvi != undefined && typeof element.yieldAvi === "number" ? element.yieldAvi : 0;

                }

            } else {
                //@ts-ignore
                cust_pn = element.cust_pn;
                //@ts-ignore
                device = element.device;
                //@ts-ignore
                lotNumber = element.lotNumber;

                lotNumberCol.push({
                    rowCount: 1,
                    //@ts-ignore
                    cust_pn: element.cust_pn,
                    //@ts-ignore
                    deviceName: element.device,
                    //@ts-ignore
                    waferId: element.waferId,
                    //@ts-ignore
                    lotNumber: element.lotNumber,
                    TestDieProbe: element.totalProbe != undefined && typeof element.totalProbe === "number" ? element.totalProbe : 0,
                    GoodDieProbe: element.passProbe != undefined && typeof element.passProbe === "number" ? element.passProbe : 0,
                    FailDieProbe: element.failProbe != undefined && typeof element.failProbe === "number" ? element.failProbe : 0,
                    YieldProbe: element.yieldProbe != undefined && typeof element.yieldProbe === "number" ? element.yieldProbe : 0,
                    TestDieAvi: element.totalAvi != undefined && typeof element.totalAvi === "number" ? element.totalAvi : 0,
                    GoodDieAvi: element.passAvi != undefined && typeof element.passAvi === "number" ? element.passAvi : 0,
                    YieldAvi: element.yieldAvi != undefined && typeof element.yieldAvi === "number" ? element.yieldAvi : 0,
                })
            }
        })


        //1000자리 구분자 넣기
        searchData.map((element) => {
            element.totalProbe = element.totalProbe != undefined ? addCommaToString(+element.totalProbe) : undefined;
            element.passProbe = element.passProbe != undefined ? addCommaToString(+element.passProbe) : undefined;
            element.failProbe = element.failProbe != undefined ? addCommaToString(+element.failProbe) : undefined;
            element.totalAvi = element.totalAvi != undefined ? addCommaToString(+element.totalAvi) : undefined;
            element.passAvi = element.passAvi != undefined ? addCommaToString(+element.passAvi) : undefined;
        })
        
        
        startTransition(()=>{
            setTableBodies((
                <tbody key={"bodies"}>
                {searchData.map((element,index) => (
                    <React.Fragment key={"body"+index}>
                        <tr>
                            {element.cellColor == undefined? <td><span>{element.cust_pn}</span></td> : <td style={{backgroundColor:element.cellColor, fontWeight: 'bold'}}><span>{element.cust_pn}</span></td>}
                            {element.cellColor == undefined? <td><span>{element.device}</span></td> : <td style={{backgroundColor:element.cellColor, fontWeight: 'bold'}}><span>{element.device}</span></td>}
                            {element.cellColor == undefined? <td><span>{element.lotNumber}</span></td> : <td style={{backgroundColor:element.cellColor, fontWeight: 'bold'}}><span>{element.lotNumber}</span></td>}
                            {element.cellColor == undefined? <td><span>{element.waferId}</span></td> : <td style={{backgroundColor:element.cellColor, fontWeight: 'bold'}}><span>{element.waferId}</span></td>}
                            {element.cellColor == undefined? <td><span>{element.totalProbe}</span></td> : <td style={{backgroundColor:element.cellColor, fontWeight: 'bold'}}><span>{element.totalProbe}</span></td>}
                            {element.cellColor == undefined? <td><span>{element.passProbe}</span></td> : <td style={{backgroundColor:element.cellColor, fontWeight: 'bold'}}><span>{element.passProbe}</span></td>}
                            {element.cellColor == undefined? <td><span>{element.failProbe}</span></td> : <td style={{backgroundColor:element.cellColor, fontWeight: 'bold'}}><span>{element.failProbe}</span></td> }
                            {element.cellColor == undefined? <td><span>{element.yieldProbe}</span></td> : <td style={{backgroundColor:element.cellColor, fontWeight: 'bold'}}><span>{element.yieldProbe}</span></td>}
                            {element.cellColor == undefined? <td><span>{element.totalAvi}</span></td> : <td style={{backgroundColor:element.cellColor, fontWeight: 'bold'}}><span>{element.totalAvi}</span></td>}
                            {element.cellColor == undefined? <td><span>{element.passAvi}</span></td> : <td style={{backgroundColor:element.cellColor, fontWeight: 'bold'}}><span>{element.passAvi}</span></td>}
                            {element.cellColor == undefined? <td><span>{element.yieldAvi}</span></td> : <td style={{backgroundColor:element.cellColor, fontWeight: 'bold'}}><span>{element.yieldAvi}</span></td>}
                            {element.cellColor == undefined? <td><span>{element.shipmentDate}</span></td> : <td style={{backgroundColor:element.cellColor, fontWeight: 'bold'}}><span>{element.shipmentDate}</span></td>}
                            
                        </tr>
                    </React.Fragment>
                ))}
                </tbody>
            ));
        })

    },[searchData])

    useEffect (() =>{
        console.log(sortType);
        console.log(sortHeader);
    },[sortType, sortHeader])

    function addCommaToString(price:number) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    const existBothDataChanged = ((e:ChangeEvent<HTMLInputElement>)=>{
            setExistBothData(e.target.checked);
    })
        
    return (
        <S.Container isLookDown={isLookDown} >
            <form onSubmit={onSubmit}>
                <div className='condition-container'>
                    {/*
                    <div className="test-degree-container" >
                        <div className="degree" >
                            <input className="check-box" type="checkbox" defaultChecked/>
                            <label>Last Test Sequence</label>
                        </div>
                        <div >
                            <input className="check-box" type="checkbox"  onChange={existBothDataChanged}  />
                            <label>Both PROBE and AVI</label>
                        </div>
                    </div>
                    */}
                    {/* <SearchSelectorNew
                        title={langState.isKor ? "제품" : "Device"}
                        list={devices}
                        selected={checkedDevices}
                        selector={setCheckedDevices}
                    /> */}
                    {/* 제품, LOT 번호, 공정, LOT Status */}
                    <SearchSelectorNew
                        title={langState.isKor ? "고객 P/N" : "CUSTOMER P/N"}
                        list={customerPns}
                        selected={checkedCustomerPns}
                        selector={setCheckedCustomerPns}
                    />
                    <SearchSelectorNew
                        title={langState.isKor ? "LOT번호" : "LOT Numbers"}
                        list={lotNumbers}
                        selected={checkedLotNumbers}
                        selector={setCheckedLotNumbers}
                    />            
                </div>
                <TableForm
                    name="TotalYieldReport"
                    tableHeaders={tableHeaders}
                    tableBodies={tableBodies}
                    CSVHeaders={CSVHeaders}
                    CSVData={searchData}
                    isLookDown={isLookDown}
                    setIsLookDown={setIsLookDown}
                    isDateRange={true}
                    isDatePicker={true}   /* 날짜 입력 On : true - Off : faslse 기능임.*/
                    startDate={startDate}
                    endDate={endDate}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    isSortHeader = {false}
                    sortHeader={sortHeader}
                    setSortHeader={setSortHeader}
                    sortType={sortType}
                    setSortType={setSortType}
                    sortingCol={sortingCol}
                />
            </form>
        </S.Container>
    )
}

export default TotalYield;
